import { addContextBannerEvent } from "../common/context-banner-event";
class ContextBanner extends lm.Composant {
  constructor(componentName) {
    super(componentName);
    addContextBannerEvent();
  }
}
lm.DOMReady(() => {
  new ContextBanner('contextbanner');
});